<div class="bg-gray-800/50 rounded-lg border border-gray-700/50 backdrop-blur-sm p-5">
  <div class="flex items-center justify-between mb-4">
    <div>
      <h3 class="text-lg font-semibold text-gray-100 mb-1">Menu Structuur</h3>
      <p class="text-sm text-gray-400">Sleep items om ze te herordenen of te nesten</p>
    </div>
    <div class="flex gap-2">
      <button
        (click)="openAddToMenuForm()"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        Pagina
        <span *ngIf="getUnassignedPages().length > 0" class="ml-2 px-2 py-0.5 text-xs font-semibold rounded-full bg-indigo-500/30">
          {{ getUnassignedPages().length }}
        </span>
      </button>
      <button
        (click)="showAddUrlForm = true"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
        URL
      </button>
      <button
        (click)="showAddPostForm = true; postSearchTerm = ''; loadAvailablePosts()"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-amber-600 hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
        </svg>
        Post
      </button>
      <button
        (click)="showAddProjectForm = true; projectSearchTerm = ''; loadAvailableProjects()"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
        Project
      </button>
    </div>
  </div>

  <div cdkDropListGroup>
    <div cdkDropList 
         [cdkDropListData]="rootPages"
         (cdkDropListDropped)="drop($event)"
         class="menu-list space-y-2">
      <div *ngFor="let page of rootPages" 
           class="menu-item" 
           cdkDrag>
        <div class="flex items-center justify-between p-3 bg-gray-900/50 rounded-lg border border-gray-700/50 
                    hover:border-gray-600 transition-colors cursor-move">
          <div class="flex items-center">
            <div class="cdkDragHandle mr-2 text-gray-500">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16" />
              </svg>
            </div>
            <!-- External link icon -->
            <svg *ngIf="page.isExternalLink" class="w-3.5 h-3.5 mr-1.5 text-emerald-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
            <span class="text-gray-200">{{ page.title }}</span>
            <span *ngIf="page.isExternalLink" class="ml-2 text-xs text-gray-500 truncate max-w-[200px]">{{ page.externalUrl }}</span>
            <!-- Display type badge -->
            <span *ngIf="page.menuDisplayType === 'mega'" class="ml-2 px-1.5 py-0.5 text-[10px] font-medium rounded bg-purple-500/20 text-purple-300">MEGA</span>
            <span *ngIf="page.menuDisplayType === 'advertising'" class="ml-2 px-1.5 py-0.5 text-[10px] font-medium rounded bg-amber-500/20 text-amber-300">AD</span>
          </div>
          <div class="flex items-center space-x-2 text-gray-400">
            <!-- Settings toggle (display type) -->
            <button *ngIf="!page.isExternalLink" (click)="toggleSettings(page)"
                    class="p-1.5 rounded-lg transition-colors"
                    [class.text-indigo-400]="expandedSettingsPages.has(page.id)"
                    [class.text-gray-400]="!expandedSettingsPages.has(page.id)"
                    title="Menu weergave instellingen">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </button>
            <button *ngIf="!page.isExternalLink" (click)="toggleHomepage(page)"
                    class="p-1.5 rounded-lg transition-colors"
                    [class.text-gray-400]="page.isHomepage !== true"
                    [class.text-yellow-400]="page.isHomepage === true"
                    [class.hover:text-gray-300]="page.isHomepage !== true"
                    [class.hover:text-yellow-300]="page.isHomepage === true"
                    [title]="page.isHomepage === true ? 'Homepage - klik om te verwijderen' : 'Instellen als homepage'">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            </button>
            <button (click)="togglePublished(page)" 
                    class="p-1.5 rounded-lg transition-colors"
                    [class.text-gray-400]="page.published === false"
                    [class.text-green-400]="page.published !== false"
                    [class.hover:text-gray-300]="page.published === false"
                    [class.hover:text-green-300]="page.published !== false"
                    [title]="page.published === false ? 'Publiceren' : 'Depubliceren'">
              <svg *ngIf="page.published === false" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
              <svg *ngIf="page.published !== false" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </button>
            <button (click)="toggleChildren(page)" *ngIf="page.children?.length" class="hover:text-indigo-400">
              <svg class="w-4 h-4 transform transition-transform" 
                   [class.rotate-180]="expandedPages.has(page.id)"
                   fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <button (click)="makeChild(page)" 
                    *ngIf="findPreviousPage(page)"
                    class="p-1.5 rounded-lg text-gray-400 hover:text-indigo-400 transition-colors"
                    title="Maak onderliggend item van vorige item">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7-7-7m14-8l-7 7-7-7" />
              </svg>
            </button>
            <button *ngIf="!page.isExternalLink || page.route?.startsWith('post-')"
                    (click)="editMenuItem(page); $event.stopPropagation()"
                    class="p-1.5 rounded-lg text-gray-400 hover:text-blue-400 transition-colors"
                    title="Bewerken">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </button>
            <button (click)="removeFromMenu(page)"
                    class="p-1.5 rounded-lg text-gray-400 hover:text-red-400 transition-colors"
                    title="Verwijderen uit menu">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Menu Display Settings Panel -->
        <div *ngIf="expandedSettingsPages.has(page.id) && !page.isExternalLink"
             class="mt-2 p-4 bg-gray-900/70 rounded-lg border border-gray-700/50 space-y-4">
          <div>
            <label class="block text-xs font-medium text-gray-400 mb-1.5">Menu weergave</label>
            <select
              [ngModel]="page.menuDisplayType || 'default'"
              (ngModelChange)="updateMenuDisplayType(page, $event)"
              class="w-full bg-gray-800 border border-gray-600 rounded-md px-3 py-2 text-sm text-gray-200 focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
              <option value="default">Standaard dropdown</option>
              <option value="mega">Mega Menu (kolommen)</option>
              <option value="advertising">Advertising (met uitgelicht blok)</option>
            </select>
          </div>

          <!-- Advertising highlight fields -->
          <div *ngIf="page.menuDisplayType === 'advertising'" class="space-y-3 pt-2 border-t border-gray-700/50">
            <p class="text-xs font-medium text-amber-400">Uitgelicht blok</p>
            <div>
              <label class="block text-xs text-gray-400 mb-1">Afbeelding</label>
              <!-- Image preview -->
              <div *ngIf="page.menuHighlight?.image" class="mb-2 relative group/img">
                <img [src]="page.menuHighlight?.image" alt="Highlight afbeelding"
                     class="w-full h-32 object-cover rounded-md border border-gray-600">
                <button (click)="removeHighlightImage(page)"
                        class="absolute top-1.5 right-1.5 p-1 rounded-md bg-red-600/80 hover:bg-red-600 text-white opacity-0 group-hover/img:opacity-100 transition-opacity"
                        title="Afbeelding verwijderen">
                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Select button -->
              <button (click)="openMediaSelectorForHighlight(page)"
                      class="w-full flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium rounded-md text-gray-200 bg-gray-700 border border-gray-600 hover:bg-gray-600 hover:border-gray-500 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                {{ page.menuHighlight?.image ? 'Andere afbeelding kiezen' : 'Afbeelding kiezen uit Media' }}
              </button>
            </div>
            <div>
              <label class="block text-xs text-gray-400 mb-1">Titel</label>
              <input type="text"
                     [ngModel]="page.menuHighlight?.title || ''"
                     (ngModelChange)="initMenuHighlight(page); page.menuHighlight!.title = $event"
                     placeholder="Uitgelichte titel..."
                     class="w-full bg-gray-800 border border-gray-600 rounded-md px-3 py-1.5 text-sm text-gray-200 placeholder-gray-500 focus:ring-2 focus:ring-amber-500 focus:border-transparent">
            </div>
            <div>
              <label class="block text-xs text-gray-400 mb-1">Beschrijving</label>
              <textarea
                [ngModel]="page.menuHighlight?.description || ''"
                (ngModelChange)="initMenuHighlight(page); page.menuHighlight!.description = $event"
                placeholder="Korte beschrijving..."
                rows="2"
                class="w-full bg-gray-800 border border-gray-600 rounded-md px-3 py-1.5 text-sm text-gray-200 placeholder-gray-500 focus:ring-2 focus:ring-amber-500 focus:border-transparent resize-none"></textarea>
            </div>
            <div class="grid grid-cols-2 gap-3">
              <div>
                <label class="block text-xs text-gray-400 mb-1">CTA tekst</label>
                <input type="text"
                       [ngModel]="page.menuHighlight?.ctaText || ''"
                       (ngModelChange)="initMenuHighlight(page); page.menuHighlight!.ctaText = $event"
                       placeholder="Lees meer"
                       class="w-full bg-gray-800 border border-gray-600 rounded-md px-3 py-1.5 text-sm text-gray-200 placeholder-gray-500 focus:ring-2 focus:ring-amber-500 focus:border-transparent">
              </div>
              <div>
                <label class="block text-xs text-gray-400 mb-1">CTA URL</label>
                <input type="text"
                       [ngModel]="page.menuHighlight?.ctaUrl || ''"
                       (ngModelChange)="initMenuHighlight(page); page.menuHighlight!.ctaUrl = $event"
                       placeholder="/pagina of https://..."
                       class="w-full bg-gray-800 border border-gray-600 rounded-md px-3 py-1.5 text-sm text-gray-200 placeholder-gray-500 focus:ring-2 focus:ring-amber-500 focus:border-transparent">
              </div>
            </div>
            <button (click)="saveMenuHighlight(page)"
                    class="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md text-white bg-amber-600 hover:bg-amber-500 transition-colors">
              Highlight opslaan
            </button>
          </div>
        </div>

        <!-- Child Items -->
        <div *ngIf="page.children?.length && expandedPages.has(page.id)"
             cdkDropList
             [cdkDropListData]="page.children"
             (cdkDropListDropped)="drop($event)"
             class="ml-6 mt-2 space-y-2 pl-4 border-l border-gray-700">
          <div *ngFor="let child of page.children"
               cdkDrag
               class="menu-item">
            <div class="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg border border-gray-700/50 
                        hover:border-gray-600 transition-colors cursor-move">
              <div class="flex items-center">
                <div class="cdkDragHandle mr-2 text-gray-500">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16" />
                  </svg>
                </div>
                <svg *ngIf="child.isExternalLink" class="w-3.5 h-3.5 mr-1.5 text-emerald-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                <span class="text-gray-200">{{ child.title }}</span>
                <span *ngIf="child.isExternalLink" class="ml-2 text-xs text-gray-500 truncate max-w-[150px]">{{ child.externalUrl }}</span>
              </div>
              <div class="flex items-center space-x-2">
                <button (click)="toggleHomepage(child)" 
                        class="p-1.5 rounded-lg transition-colors"
                        [class.text-gray-400]="child.isHomepage !== true"
                        [class.text-yellow-400]="child.isHomepage === true"
                        [class.hover:text-gray-300]="child.isHomepage !== true"
                        [class.hover:text-yellow-300]="child.isHomepage === true"
                        [title]="child.isHomepage === true ? 'Homepage - klik om te verwijderen' : 'Instellen als homepage'">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                </button>
                <button (click)="togglePublished(child)" 
                        class="p-1.5 rounded-lg transition-colors"
                        [class.text-gray-400]="child.published === false"
                        [class.text-green-400]="child.published !== false"
                        [class.hover:text-gray-300]="child.published === false"
                        [class.hover:text-green-300]="child.published !== false"
                        [title]="child.published === false ? 'Publiceren' : 'Depubliceren'">
                  <svg *ngIf="child.published === false" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                  </svg>
                  <svg *ngIf="child.published !== false" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </button>
                <button (click)="makeRoot(child)" 
                        class="p-1.5 rounded-lg text-gray-400 hover:text-indigo-400 transition-colors"
                        title="Maak hoofdniveau item">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
                  </svg>
                </button>
                <button *ngIf="!child.isExternalLink || child.route?.startsWith('post-')"
                        (click)="editMenuItem(child); $event.stopPropagation()"
                        class="p-1.5 rounded-lg text-gray-400 hover:text-blue-400 transition-colors"
                        title="Bewerken">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                </button>
                <button (click)="removeFromMenu(child)"
                        class="p-1.5 rounded-lg text-gray-400 hover:text-red-400 transition-colors"
                        title="Verwijderen uit menu">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add External URL Modal -->
<div *ngIf="showAddUrlForm" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="add-url-modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" (click)="showAddUrlForm = false"></div>
  <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
    <div class="relative w-full max-w-md transform overflow-hidden rounded-xl bg-gray-800 shadow-2xl transition-all border border-gray-700/50"
         (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between border-b border-gray-700/50 px-4 py-3 sm:px-5 sm:py-3.5">
        <h3 class="text-lg font-semibold text-gray-100" id="add-url-modal-title">
          URL Toevoegen aan Menu
        </h3>
        <button (click)="showAddUrlForm = false"
                class="text-gray-400 hover:text-gray-200 transition-colors rounded-lg p-1">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="px-4 py-4 sm:px-5 sm:py-5 space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-300 mb-1">Label</label>
          <input type="text"
                 [(ngModel)]="newLinkTitle"
                 placeholder="Menu tekst..."
                 class="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2.5 text-white placeholder-gray-500 focus:ring-2 focus:ring-emerald-500 focus:border-transparent">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-300 mb-1">URL</label>
          <input type="url"
                 [(ngModel)]="newLinkUrl"
                 placeholder="https://..."
                 class="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2.5 text-white placeholder-gray-500 focus:ring-2 focus:ring-emerald-500 focus:border-transparent">
        </div>
        <div class="flex items-center">
          <input type="checkbox"
                 [(ngModel)]="newLinkOpenInNewTab"
                 id="openInNewTab"
                 class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-emerald-600 focus:ring-emerald-500">
          <label for="openInNewTab" class="ml-2 text-sm text-gray-300">Open in nieuw tabblad</label>
        </div>
        <button (click)="addExternalLink()"
                [disabled]="!newLinkTitle || !newLinkUrl"
                class="w-full inline-flex items-center justify-center px-4 py-2.5 text-sm font-medium rounded-lg text-white bg-emerald-600 hover:bg-emerald-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
          </svg>
          URL Toevoegen
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Post to Menu Modal -->
<div *ngIf="showAddPostForm" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="add-post-modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" (click)="showAddPostForm = false"></div>
  <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
    <div class="relative w-full max-w-md transform overflow-hidden rounded-xl bg-gray-800 shadow-2xl transition-all border border-gray-700/50"
         (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between border-b border-gray-700/50 px-4 py-3 sm:px-5 sm:py-3.5">
        <h3 class="text-lg font-semibold text-gray-100" id="add-post-modal-title">
          Post Toevoegen aan Menu
        </h3>
        <button (click)="showAddPostForm = false"
                class="text-gray-400 hover:text-gray-200 transition-colors rounded-lg p-1">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="px-4 pt-3 sm:px-5">
        <input type="text"
          [(ngModel)]="postSearchTerm"
          placeholder="Zoek post..."
          class="w-full px-3 py-2 rounded-lg bg-gray-700 border border-gray-600 text-sm text-gray-200 placeholder-gray-500 focus:ring-amber-500 focus:border-amber-500">
      </div>
      <div class="px-4 py-3 sm:px-5 space-y-3 max-h-80 overflow-y-auto">
        <div *ngIf="filteredPosts.length === 0" class="text-center py-6">
          <p class="text-sm text-gray-400">Geen posts gevonden</p>
        </div>
        <button
          *ngFor="let post of filteredPosts"
          (click)="addPostToMenu(post)"
          class="w-full text-left px-4 py-3 rounded-lg bg-gray-700/50 hover:bg-gray-700 border border-gray-600/50 hover:border-amber-500/50 transition-all group">
          <div class="flex items-center gap-3">
            <svg class="w-5 h-5 text-amber-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
            </svg>
            <div class="min-w-0 flex-1">
              <p class="text-sm font-medium text-gray-200 truncate group-hover:text-white">{{ post.title }}</p>
              <p class="text-xs text-gray-500 truncate">/{{ post.slug }}</p>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Project to Menu Modal -->
<div *ngIf="showAddProjectForm" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="add-project-modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" (click)="showAddProjectForm = false"></div>
  <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
    <div class="relative w-full max-w-md transform overflow-hidden rounded-xl bg-gray-800 shadow-2xl transition-all border border-gray-700/50"
         (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between border-b border-gray-700/50 px-4 py-3 sm:px-5 sm:py-3.5">
        <h3 class="text-lg font-semibold text-gray-100" id="add-project-modal-title">
          Project Toevoegen aan Menu
        </h3>
        <button (click)="showAddProjectForm = false"
                class="text-gray-400 hover:text-gray-200 transition-colors rounded-lg p-1">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="px-4 pt-3 sm:px-5">
        <input type="text"
          [(ngModel)]="projectSearchTerm"
          placeholder="Zoek project..."
          class="w-full px-3 py-2 rounded-lg bg-gray-700 border border-gray-600 text-sm text-gray-200 placeholder-gray-500 focus:ring-cyan-500 focus:border-cyan-500">
      </div>
      <div class="px-4 py-3 sm:px-5 space-y-3 max-h-80 overflow-y-auto">
        <div *ngIf="filteredProjects.length === 0" class="text-center py-6">
          <p class="text-sm text-gray-400">Geen projecten gevonden</p>
        </div>
        <button
          *ngFor="let project of filteredProjects"
          (click)="addProjectToMenu(project)"
          class="w-full text-left px-4 py-3 rounded-lg bg-gray-700/50 hover:bg-gray-700 border border-gray-600/50 hover:border-cyan-500/50 transition-all group">
          <div class="flex items-center gap-3">
            <svg class="w-5 h-5 text-cyan-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <div class="min-w-0 flex-1">
              <p class="text-sm font-medium text-gray-200 truncate group-hover:text-white">{{ project.title || project.title_nl }}</p>
              <p class="text-xs text-gray-500 truncate">/projecten/{{ project.slug }}</p>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Pages to Menu Modal -->
<div *ngIf="showAddToMenuForm" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="add-pages-modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" (click)="showAddToMenuForm = false"></div>

  <!-- Modal container -->
  <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
    <div class="relative w-full max-w-2xl transform overflow-hidden rounded-xl bg-gray-800 shadow-2xl transition-all border border-gray-700/50" 
         (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="flex items-center justify-between border-b border-gray-700/50 px-4 py-3 sm:px-5 sm:py-3.5">
        <h3 class="text-lg font-semibold text-gray-100" id="add-pages-modal-title">
          Pagina's Toevoegen aan Menu
        </h3>
        <button
          (click)="showAddToMenuForm = false"
          class="text-gray-400 hover:text-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded-lg p-1"
          aria-label="Close modal">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Modal content -->
      <div class="px-4 py-4 sm:px-5 sm:py-5">
        <div *ngIf="getUnassignedPages().length === 0" class="text-center py-8 text-gray-400">
          <svg class="w-12 h-12 mx-auto mb-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p class="text-sm">Alle pagina's zijn al toegevoegd aan het menu</p>
        </div>
        
        <div *ngIf="getUnassignedPages().length > 0" class="space-y-2 max-h-[60vh] overflow-y-auto pr-1 -mr-1">
          <div *ngFor="let page of getUnassignedPages()" 
               class="flex items-center justify-between p-3 bg-gray-900/50 rounded-lg border border-gray-700/50 hover:border-gray-600 hover:bg-gray-900 transition-colors">
            <div class="flex-1 min-w-0">
              <div class="text-sm font-medium text-gray-200 truncate">{{ page.title || 'Zonder titel' }}</div>
              <div class="text-xs text-gray-400 mt-1">/{{ page.route }}</div>
            </div>
            <button (click)="addUnassignedPageToMenu(page)"
                    class="ml-4 flex-shrink-0 inline-flex items-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500">
              Toevoegen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Media Selector Modal for Advertising Highlight Image -->
<app-media-selector-modal
  [show]="showMediaSelectorModal"
  (onSelect)="onHighlightMediaSelected($event)"
  (onClose)="closeMediaSelector()">
</app-media-selector-modal>